module.exports = __webpack_public_path__ + "static/street-shanghai-c09d8c11776b478aab9d7076a304e0ac.png";